'use client'

import { FC } from 'react'
import { CmsAsset, CmsResponsiveImage } from '../PageHero'
import { CmsPageSectionBase } from '@/components/ComposedPage'
import { FaqSection } from '@/components/FaqSection'
import { Glossary } from '@/components/Glossary'
import { RichTextContent } from '@/hooks/useRichText'
import { CmsAuthor, CmsBase } from '@/components/Blog/types'
import { Colour } from '@/components/constants/colours'

export enum InfoAccordionFormat {
  Glossary = 'Glossary',
  FAQ = 'FAQ',
}

export interface CmsInfoAccordionItem extends CmsBase {
  fields: {
    title: string
    firstParagraph: string
    expansionText?: RichTextContent
    author?: CmsAuthor
    video?: CmsAsset
    videoPoster?: CmsAsset
  }
}

export interface CmsInfoAccordionSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    title?: string
    titleIdentImage?: CmsResponsiveImage
    format?: InfoAccordionFormat
    items?: CmsInfoAccordionItem[]
    footerText?: RichTextContent
    backgroundColour: Colour
  }
}

export const InfoAccordion: FC<CmsInfoAccordionSection> = props => {
  const {
    title = '',
    format,
    items = [],
    backgroundColour = Colour.warmStone,
  } = props.fields

  return format === InfoAccordionFormat.Glossary ? (
    <Glossary
      format={format}
      definitions={items}
      title={title}
      backgroundColour={backgroundColour}
    />
  ) : (
    <FaqSection {...props} />
  )
}
